import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Person } from '../model/person';
import { Personorg } from '../model/personorg';

@Injectable({
  providedIn: 'root'
})
export class OrguseraddService {

  constructor(private http:HttpClient) { }

  createPersonOrg(org:Personorg){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    //POST /person/{personId}/organization/{organizationId}/joiner
    var reqJoinUrl = environment.apiUrl+'/person/'+org.personId+'/organization/'+org.organizationId+'/joiner';
    var body = JSON.stringify(org);
    ////console.log('req url: '+reqJoinUrl);
    //console.log('body: '+body);
    return this.http.post(reqJoinUrl,body,httpOptions);
  }

  addPerson(personId:string,person:Person){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<Person>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId,JSON.stringify(person),httpOptions);
  }
  makeMember(joiner:Personorg,organizationId:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var acceptJoinerUrl = environment.apiUrl + '/organization/' + organizationId + '/pendingjoiners/'+joiner.personId+'/accept'
    return this.http.post(acceptJoinerUrl,JSON.stringify(joiner), httpOptions);
  }

}
